import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon, obj = logged
  const [token, setToken] = useState(localStorage.getItem("rmb_token"));

  useEffect(() => {
    let active = true;
    async function load() {
      if (!token) { setUser(null); return; }
      try {
        const { data } = await api.get("/auth/me");
        if (active) setUser(data);
      } catch {
        localStorage.removeItem("rmb_token");
        if (active) { setUser(null); setToken(null); }
      }
    }
    load();
    return () => { active = false; };
  }, [token]);

  const applyAuth = (tok, usr) => {
    localStorage.setItem("rmb_token", tok);
    setToken(tok);
    setUser(usr);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applyAuth(data.token, data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("rmb_token");
    setToken(null);
    setUser(null);
  };

  const isAdmin = user && user.role === "admin";

  return (
    <AuthContext.Provider value={{ user, isAdmin, login, logout, applyAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
